(() => {
  const guide = document.querySelector('[data-ai-guide]');
  const toast = document.querySelector('.site-toast');
  if (!guide) return;

  const panel = guide.querySelector('.ai-panel');
  const closeButton = guide.querySelector('[data-ai-close]');
  const form = guide.querySelector('[data-ai-form]');
  const messageArea = guide.querySelector('.ai-messages');
  const endpoint = guide.dataset.aiEndpoint || '';
  const storeRoot = window.Shopify?.routes?.root || '/';
  const currency = window.Shopify?.currency?.active || 'USD';
  const locale = document.documentElement.lang || 'en';
  const language = locale.slice(0, 2).toLowerCase();
  const localizedCopy = {
    en: { loading: 'Searching the live catalogue…', summary: 'I searched {count} available pieces and selected the strongest matches using product details, tags, price and availability.', none: 'No sufficiently relevant available match was found. Try a different budget, color or placement.', failure: 'I could not read the catalogue just now. Please browse the collections or contact our support team for a personal recommendation.', toast: 'The catalogue guide is temporarily unavailable.', budget: 'within your {currency} {budget} budget', wearable: 'wearable scale', statement: 'statement scale', office: 'suited to a desk or office', interior: 'designed for interior display', personalized: 'personalization cues', color: '{color} color match', fallback: 'strong match across title, description and product tags' },
    fr: { loading: 'Recherche dans le catalogue en cours…', summary: 'J’ai analysé {count} pièces disponibles et retenu les correspondances les plus pertinentes selon les détails, les tags, le prix et la disponibilité.', none: 'Aucune correspondance disponible suffisamment pertinente. Essayez un autre budget, une autre couleur ou un autre emplacement.', failure: 'Le catalogue est momentanément inaccessible. Parcourez les collections ou contactez-nous pour un conseil personnalisé.', toast: 'Le guide du catalogue est momentanément indisponible.', budget: 'dans votre budget de {budget} {currency}', wearable: 'format à porter', statement: 'format monumental', office: 'adapté à un bureau', interior: 'conçu pour la décoration intérieure', personalized: 'possibilités de personnalisation', color: 'correspondance de couleur {color}', fallback: 'forte correspondance avec le titre, la description et les tags' },
    de: { loading: 'Der aktuelle Katalog wird durchsucht…', summary: 'Ich habe {count} verfügbare Stücke geprüft und die stärksten Treffer anhand von Details, Tags, Preis und Verfügbarkeit ausgewählt.', none: 'Kein ausreichend relevanter verfügbarer Treffer. Versuchen Sie ein anderes Budget, eine andere Farbe oder Platzierung.', failure: 'Der Katalog ist gerade nicht erreichbar. Bitte stöbern Sie in den Kollektionen oder kontaktieren Sie uns für eine persönliche Empfehlung.', toast: 'Die Katalogberatung ist vorübergehend nicht verfügbar.', budget: 'innerhalb Ihres Budgets von {budget} {currency}', wearable: 'tragbares Format', statement: 'monumentales Format', office: 'für Schreibtisch oder Büro geeignet', interior: 'für die Raumgestaltung gedacht', personalized: 'Hinweise auf Personalisierung', color: 'Farbtreffer: {color}', fallback: 'starke Übereinstimmung mit Titel, Beschreibung und Tags' },
    es: { loading: 'Buscando en el catálogo disponible…', summary: 'He revisado {count} piezas disponibles y seleccionado las coincidencias más sólidas según detalles, etiquetas, precio y disponibilidad.', none: 'No se encontró una coincidencia disponible suficientemente relevante. Prueba con otro presupuesto, color o ubicación.', failure: 'Ahora mismo no puedo consultar el catálogo. Explora las colecciones o contáctanos para recibir una recomendación personal.', toast: 'La guía del catálogo no está disponible temporalmente.', budget: 'dentro de tu presupuesto de {budget} {currency}', wearable: 'escala para llevar', statement: 'escala monumental', office: 'adecuado para escritorio u oficina', interior: 'diseñado para interiores', personalized: 'opciones de personalización', color: 'coincidencia de color {color}', fallback: 'coincidencia sólida con título, descripción y etiquetas' },
    it: { loading: 'Ricerca nel catalogo disponibile…', summary: 'Ho esaminato {count} opere disponibili e selezionato le corrispondenze più forti in base a dettagli, tag, prezzo e disponibilità.', none: 'Non è stata trovata una corrispondenza disponibile abbastanza pertinente. Prova un altro budget, colore o ambiente.', failure: 'Al momento non riesco a leggere il catalogo. Esplora le collezioni o contattaci per un consiglio personale.', toast: 'La guida al catalogo non è temporaneamente disponibile.', budget: 'entro il tuo budget di {budget} {currency}', wearable: 'formato da indossare', statement: 'formato monumentale', office: 'adatto a scrivania o ufficio', interior: 'pensato per gli interni', personalized: 'possibilità di personalizzazione', color: 'corrispondenza colore {color}', fallback: 'forte corrispondenza con titolo, descrizione e tag' }
  };
  const copy = localizedCopy[language] || localizedCopy.en;
  const localizedColors = {
    en: ['blue', 'purple', 'gold', 'red', 'green'], fr: ['bleu', 'violet', 'or', 'rouge', 'vert'],
    de: ['Blau', 'Violett', 'Gold', 'Rot', 'Grün'], es: ['azul', 'morado', 'dorado', 'rojo', 'verde'],
    it: ['blu', 'viola', 'oro', 'rosso', 'verde']
  };
  let catalogPromise;
  let toastTimer;
  let triggerElement;

  const groups = [
    ['gift', 'birthday', 'anniversary', 'present', 'recipient', 'cadeau', 'anniversaire', 'geschenk', 'geburtstag', 'regalo', 'compleanno', '礼物', '生日', '纪念日', '送人'],
    ['office', 'desk', 'work', 'career', 'study', 'workspace', 'bureau', 'travail', 'schreibtisch', 'buro', 'oficina', 'escritorio', 'ufficio', 'scrivania', '办公室', '书房', '桌面', '办公'],
    ['living', 'room', 'entryway', 'cabinet', 'home', 'decor', 'display', 'salon', 'interieur', 'wohnzimmer', 'raum', 'interior', 'soggiorno', 'casa', '客厅', '玄关', '家居', '摆件', '装饰'],
    ['wearable', 'jewelry', 'jewellery', 'pendant', 'necklace', 'bracelet', 'keychain', 'car hanging', 'bijou', 'pendentif', 'collier', 'tragbar', 'schmuck', 'anhänger', 'joya', 'colgante', 'collana', 'bracciale', '首饰', '项链', '吊坠', '手链', '钥匙扣', '车挂'],
    ['large', 'statement', 'sculpture', 'vase', 'statue', 'centerpiece', 'monumental', 'grande', 'gross', 'skulptur', 'gran', 'escultura', 'grande formato', 'scultura', '大件', '大型', '雕塑', '花瓶'],
    ['custom', 'personalized', 'personalised', 'engraving', 'engraved', 'bespoke', 'sur mesure', 'gravure', 'massanfertigung', 'gravur', 'personalizado', 'grabado', 'su misura', 'incisione', '定制', '刻字', '个性化'],
    ['love', 'romance', 'couple', 'wedding', 'heart', '爱情', '情侣', '婚礼', '爱心'],
    ['blue', 'teal', 'cyan', 'turquoise', 'navy', 'bleu', 'blau', 'azul', 'blu', '蓝色', '青色', '蓝'],
    ['purple', 'violet', 'amethyst', 'violett', 'morado', 'viola', '紫色', '紫'],
    ['gold', 'golden', 'amber', 'yellow', 'or', 'dorado', 'oro', '金色', '琥珀', '黄色'],
    ['red', 'crimson', 'ruby', 'rouge', 'rot', 'rojo', 'rosso', '红色', '红'],
    ['green', 'emerald', 'jade', 'vert', 'grun', 'verde', '绿色', '绿'],
    ['animal', 'fish', 'whale', 'jellyfish', 'dragon', 'horse', 'rabbit', 'bird', '动物', '鱼', '鲸鱼', '水母', '龙', '马', '兔', '鸟'],
    ['lotus', 'flower', 'floral', 'buddha', 'oriental', '禅', '莲花', '花', '佛', '东方']
  ];

  const track = (name, detail = {}) => document.dispatchEvent(new CustomEvent(`luminaglaze:${name}`, { detail }));
  const showToast = (message) => {
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast.classList.remove('is-visible'), 2800);
  };
  const open = () => {
    if (!panel.classList.contains('is-open')) triggerElement = document.activeElement instanceof HTMLElement ? document.activeElement : null;
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    localStorage.setItem('luminaglaze-ai-seen', String(Date.now()));
    track('ai_open');
    setTimeout(() => form.querySelector('input')?.focus(), 160);
  };
  const close = () => {
    if (!panel.classList.contains('is-open')) return;
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    triggerElement?.focus();
  };
  const addMessage = (text, className) => {
    const item = document.createElement('div');
    item.className = `ai-message ${className}`;
    item.textContent = text;
    messageArea.append(item);
    messageArea.scrollTop = messageArea.scrollHeight;
    return item;
  };
  const stripHtml = (html = '') => {
    const node = document.createElement('div');
    node.innerHTML = html;
    return node.textContent || '';
  };
  const normalize = (value = '') => String(value).toLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, ' ').replace(/\s+/g, ' ').trim();
  const termsFor = (query) => {
    const normalized = normalize(query);
    const raw = normalized.split(/[^\p{L}\p{N}]+/u).filter((term) => term.length > 1);
    const expanded = new Set(raw);
    groups.forEach((group) => {
      if (group.some((term) => normalized.includes(term))) group.forEach((term) => expanded.add(term));
    });
    return [...expanded];
  };
  const getBudget = (query) => {
    const normalized = normalize(query).replace(/,/g, '');
    const match = normalized.match(/(?:under|below|less than|within|max(?:imum)?|budget(?: is| of)?|moins de|jusqu a|budget de|max(?:imum)?|unter|bis|budget|hochstens|weniger als|menos de|hasta|presupuesto|maximo|meno di|fino a|massimo|不超过|低于|以内|预算|小于)\s*(?:usd|us\$|\$|eur|€|gbp|£|rmb|cny|￥|¥)?\s*(\d+(?:\.\d+)?)/i)
      || normalized.match(/(?:usd|us\$|\$|eur|€|gbp|£)\s*(\d+(?:\.\d+)?)\s*(?:or less|ou moins|oder weniger|o menos|o meno|以内|以下)?/i);
    return match ? Number(match[1]) : null;
  };
  const priceOf = (product) => {
    const prices = (product.variants || []).map((variant) => Number(variant.price)).filter(Number.isFinite);
    return prices.length ? Math.min(...prices) : 0;
  };
  const isAvailable = (product) => (product.variants || []).some((variant) => variant.available !== false);
  const searchableText = (product) => normalize([
    product.title,
    product.product_type,
    Array.isArray(product.tags) ? product.tags.join(' ') : product.tags,
    stripHtml(product.body_html)
  ].filter(Boolean).join(' '));
  const scoreProduct = (product, query, terms, budget) => {
    const title = normalize(product.title);
    const type = normalize(product.product_type);
    const tags = normalize(Array.isArray(product.tags) ? product.tags.join(' ') : product.tags);
    const body = normalize(stripHtml(product.body_html));
    const full = `${title} ${type} ${tags} ${body}`;
    let score = 0;
    terms.forEach((term) => {
      if (title.includes(term)) score += 8;
      else if (type.includes(term)) score += 6;
      else if (tags.includes(term)) score += 5;
      else if (body.includes(term)) score += 2;
    });
    const normalizedQuery = normalize(query);
    if (title.includes(normalizedQuery) && normalizedQuery.length > 3) score += 15;
    groups.forEach((group) => {
      const requested = group.some((term) => normalizedQuery.includes(term));
      const matched = group.some((term) => full.includes(term));
      if (requested && matched) score += 7;
    });
    const price = priceOf(product);
    if (budget) {
      if (price > 0 && price <= budget) score += 14 + Math.max(0, 4 - ((budget - price) / budget) * 4);
      else if (price > budget) score -= 28 + ((price - budget) / budget) * 8;
    }
    if (isAvailable(product)) score += 3;
    return score;
  };
  const reasonFor = (product, query, budget) => {
    const full = searchableText(product);
    const normalizedQuery = normalize(query);
    const labels = [];
    if (budget && priceOf(product) <= budget) labels.push(copy.budget.replace('{currency}', currency).replace('{budget}', budget));
    if (groups[3].some((term) => normalizedQuery.includes(term)) && groups[3].some((term) => full.includes(term))) labels.push(copy.wearable);
    if (groups[4].some((term) => normalizedQuery.includes(term)) && groups[4].some((term) => full.includes(term))) labels.push(copy.statement);
    if (groups[1].some((term) => normalizedQuery.includes(term)) && groups[1].some((term) => full.includes(term))) labels.push(copy.office);
    if (groups[2].some((term) => normalizedQuery.includes(term)) && groups[2].some((term) => full.includes(term))) labels.push(copy.interior);
    if (groups[5].some((term) => normalizedQuery.includes(term)) && groups[5].some((term) => full.includes(term))) labels.push(copy.personalized);
    const colorIndex = groups.slice(9, 14).findIndex((group) => group.some((term) => normalizedQuery.includes(term)) && group.some((term) => full.includes(term)));
    if (colorIndex >= 0) labels.push(copy.color.replace('{color}', (localizedColors[language] || localizedColors.en)[colorIndex]));
    return labels.slice(0, 2).join(' · ') || copy.fallback;
  };
  const loadCatalog = () => {
    if (!catalogPromise) {
      catalogPromise = fetch(`${storeRoot}products.json?limit=250`, { headers: { Accept: 'application/json' } })
        .then((response) => {
          if (!response.ok) throw new Error('Catalog unavailable');
          return response.json();
        })
        .then((data) => {
          const seenTitles = new Set();
          return (data.products || []).filter(isAvailable).filter((product) => {
            const titleKey = normalize(product.title);
            if (!titleKey || seenTitles.has(titleKey)) return false;
            seenTitles.add(titleKey);
            return true;
          });
        });
    }
    return catalogPromise;
  };
  const getMatches = (products, query) => {
    const terms = termsFor(query);
    const budget = getBudget(query);
    const ranked = products
      .map((product) => ({ product, score: scoreProduct(product, query, terms, budget), reason: reasonFor(product, query, budget) }))
      .sort((a, b) => b.score - a.score || priceOf(a.product) - priceOf(b.product));
    const threshold = Math.max(6, (ranked[0]?.score || 0) * 0.45);
    return ranked.filter((item) => item.score >= threshold).slice(0, 3);
  };
  const formatPrice = (value) => {
    try { return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(value); }
    catch (_) { return `${currency} ${Number(value).toFixed(2)}`; }
  };
  const renderResults = (matches) => {
    const grid = document.createElement('div');
    grid.className = 'ai-result-grid';
    matches.forEach(({ product, reason }) => {
      const link = document.createElement('a');
      link.className = 'ai-product-result';
      link.href = `${storeRoot}products/${product.handle}`;
      const media = document.createElement('span');
      media.className = 'ai-product-result-media';
      const imageSource = product.images?.[0]?.src;
      if (imageSource) {
        const image = document.createElement('img');
        image.src = imageSource;
        image.alt = product.title;
        image.loading = 'lazy';
        media.append(image);
      }
      const copy = document.createElement('span');
      copy.className = 'ai-product-result-copy';
      const type = document.createElement('small');
      type.textContent = product.product_type || 'Curated object';
      const title = document.createElement('b');
      title.textContent = product.title;
      const why = document.createElement('em');
      why.textContent = reason;
      const price = document.createElement('strong');
      price.textContent = `${formatPrice(priceOf(product))}  →`;
      copy.append(type, title, why, price);
      link.append(media, copy);
      grid.append(link);
    });
    messageArea.append(grid);
    messageArea.scrollTop = messageArea.scrollHeight;
  };
  const externalAnswer = async (query, matches) => {
    if (!endpoint) return null;
    try {
      const candidates = matches.map(({ product, reason }) => ({
        title: product.title,
        handle: product.handle,
        type: product.product_type,
        tags: product.tags,
        price: priceOf(product),
        reason,
        description: stripHtml(product.body_html).slice(0, 700)
      }));
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ query, locale, currency, candidates })
      });
      const result = await response.json();
      return response.ok && result.answer ? result.answer : null;
    } catch (_) {
      showToast(copy.toast);
      return null;
    }
  };
  const answer = async (query) => {
    const loading = addMessage(copy.loading, 'guide-message answer-message ai-loading');
    try {
      const products = await loadCatalog();
      const matches = getMatches(products, query);
      const response = await externalAnswer(query, matches);
      loading.remove();
      const isChinese = /[\u3400-\u9fff]/.test(query);
      addMessage(
        response || (isChinese
          ? `我已从当前 ${products.length} 款在售商品中筛选出 3 个匹配结果，并综合了标题、描述、标签、价格与库存。`
          : copy.summary.replace('{count}', products.length)),
        'guide-message answer-message'
      );
      if (matches.length) renderResults(matches);
      else addMessage(isChinese ? '暂时没有找到足够相关的在售商品，请调整预算或描述。' : copy.none, 'guide-message answer-message');
      track('ai_recommendation', { query, products: matches.map(({ product }) => product.handle), mode: response ? 'endpoint' : 'catalog' });
    } catch (_) {
      loading.textContent = copy.failure;
      showToast(copy.toast);
    }
  };
  const submitPrompt = (query) => {
    if (!query) return;
    open();
    addMessage(query, 'user-message');
    answer(query);
  };

  document.querySelectorAll('[data-ai-open]').forEach((button) => {
    button.addEventListener('click', () => {
      const prompt = button.dataset.aiPrompt;
      if (prompt) submitPrompt(prompt);
      else open();
    });
  });
  guide.querySelectorAll('[data-ai-prompt]:not([data-ai-open])').forEach((button) => {
    button.addEventListener('click', () => submitPrompt(button.dataset.aiPrompt));
  });
  closeButton?.addEventListener('click', close);
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') close();
    if (event.key !== 'Tab' || !panel.classList.contains('is-open')) return;
    const focusable = Array.from(panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')).filter((element) => element.offsetParent !== null);
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });
  form?.addEventListener('submit', (event) => {
    event.preventDefault();
    const input = form.querySelector('input');
    const value = input.value.trim();
    if (!value) return;
    submitPrompt(value);
    input.value = '';
  });
  document.querySelectorAll('[data-product-form]').forEach((productForm) => productForm.addEventListener('submit', () => track('add_to_cart', { product: productForm.closest('.product-page')?.querySelector('h1')?.textContent })));
  const seen = Number(localStorage.getItem('luminaglaze-ai-seen') || 0);
  if (guide.dataset.aiAuto === 'true' && (!seen || Date.now() - seen > 7 * 24 * 60 * 60 * 1000)) setTimeout(open, 6500);
})();
